// extracted by mini-css-extract-plugin
export var bodySections = "_6b-8";
export var gray = "_6b-7";
export var green = "_6b-4";
export var iconContainer = "_6b-9";
export var iconWidgetContainer = "_6b-1";
export var phoneIcon = "_6b-2";
export var red = "_6b-5";
export var statusDot = "_6b-3";
export var widgetContainer = "_6b-0";
export var yellow = "_6b-6";